var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebookIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 34,
  height: 34,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 34,
  height: 34,
  fill: "#1877F2",
  rx: 17
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M23.617 21.914 24.371 17h-4.715v-3.187c0-1.345.658-2.657 2.77-2.657h2.144V6.973s-1.945-.332-3.805-.332c-3.884 0-6.421 2.354-6.421 6.614V17h-4.317v4.914h4.317v11.88Q15.644 34 17 34q1.356-.001 2.656-.206v-11.88z"
})));
export default SvgFacebookIcon;